import axios from 'axios';

import appSettings from '../app-settings';

const API_URL = `${appSettings.baseUrl}/accounts/users`;

/** Permanently delete a tenant user (tenant administrator only). `userId` is the user's Cognito `sub`. */
export const deleteUser = async (userId) => {
  await axios.delete(`${API_URL}/${encodeURIComponent(userId)}`);
};
